import EmptyTableRow from "../../../common/EmptyTableRow";
import React, {useEffect, useState} from "react";
import {useUser} from "../../../../util/userContext/UserContext";
import {CompanySearchParamType} from "../interface";
import {companyMemberMapInit, companySearchParamInit} from "../state";
import {useReadCompanyMember} from "../hooks/useReadCompanyMember";
import {SubmitHandler, useForm} from "react-hook-form";
import PaginationSub from "../../../../components/common/pagination/PaginationSub";


export default function Lower() {
    const {user} = useUser()

    const [searchParam, setSearchParam] = useState<CompanySearchParamType>(companySearchParamInit)

    const {data: companyMemberApiData} = useReadCompanyMember({
        param: searchParam,
        enabled: searchParam.userId !== 0
    })
    const companyMember = companyMemberApiData ?? companyMemberMapInit

    const {register, handleSubmit, setValue} =
        useForm({defaultValues: searchParam});

    useEffect(() => {
        if (user) {
            setValue("userId", user.userId)
            setSearchParam({...searchParam, userId: user.userId})
        }
    }, [user]);

    const onSubmit: SubmitHandler<CompanySearchParamType> = (submitData) => {
        setSearchParam(submitData)
    }

    return <>
        <form className="content_wrap" onSubmit={handleSubmit(onSubmit)}>
            <div className="fiter_top">
                <h3 className="filter_heading">구성원 검색</h3>
                <div className="filter_toolbar"></div>
            </div>
            <div className="row">
                <div className="col-6">
                    <div className="frm_row search justify-content-start">
                        <label className="form-label frm_label">검색어</label>
                        <select className="form-select w-150px" {...register("keywordType")}>
                            <option value="0">전체</option>
                            <option value="1">이름</option>
                            <option value="2">ID</option>
                        </select>
                        <input type="text"
                               className="form-control w-250px me-0"
                               {...register("keyword")}
                        />
                        <button className="btn btn-info btn_search">
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>
                            조회
                        </button>
                    </div>
                </div>
                <div className="col-6"></div>
            </div>
        </form>

        <div className="content_wrap">
            <div className="table_top">
                <h6 className="table_stats">구성원 목록(<span>{companyMember.totalCount}</span>건)</h6>
                <div className="table_toolbar"></div>
            </div>
            <div className="table_scroll">
                <table className="table table-bordered my_table">
                    <thead>
                    <tr>
                        <th style={{width: "20%"}}>ID</th>
                        <th style={{width: "10%"}}>이름</th>
                        <th style={{width: "10%"}}>직함</th>
                        <th style={{width: "20%"}}>부서</th>
                        <th style={{width: "20%"}}>팀</th>
                        <th style={{width: "10%"}}>역할</th>
                        <th style={{width: "10%"}}>상태</th>
                    </tr>
                    </thead>
                    <tbody>
                    {companyMember.userList.length === 0 ? (
                        <EmptyTableRow colSpan={7}/>
                    ) : (
                        companyMember.userList.map((item, index) => (
                            <tr key={index}>
                                <td className="text-center">{item.loginId}</td>
                                <td className="text-center">{item.userName}</td>
                                <td className="text-center">{item.title}</td>
                                <td className="text-center">{item.departmentName}</td>
                                <td className="text-center">{item.teamName}</td>
                                <td className="text-center">{item.roleName}</td>
                                <td className="text-center">{item.deleteFlag === "N" ? "활성" : "비활성"}</td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>

            <PaginationSub
                totalCount={companyMember.totalCount ?? 0}
                currentPage={searchParam.pageNo}
                onChangeCallback={(i: number) => setSearchParam({...searchParam, pageNo: i})}
            />
        </div>
    </>
}